function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15934_19740)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8241 3.01313C13.6165 2.22075 14.9323 2.1719 15.7925 3.01313L20.9872 8.20785C21.8069 9.02756 21.8069 10.3566 20.9872 11.1763C20.1948 11.9686 18.879 12.0268 18.0188 11.1763L17.6478 10.805L14.5502 13.9026C15.4847 16.4317 14.859 19.5528 12.8241 21.5657C12.6044 21.783 12.2663 21.7547 12.082 21.5657L7.62915 17.1128L4.28989 20.4525C4.08496 20.6575 3.75271 20.6575 3.54778 20.4525C3.35862 20.2634 3.32538 19.9347 3.54778 19.7104L6.88716 16.3708L2.43463 11.9184C2.24547 11.7292 2.20907 11.4018 2.43463 11.1763C4.42009 9.1908 7.43582 8.48017 10.0972 9.4496L13.1948 6.35203L12.8241 5.98154C11.9783 5.13137 12.0317 3.80551 12.8241 3.01313Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15934_19740"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 19.2,
  fill: "white",
  transform: "translate(2.3999 2.40039)"
})));

var SvgIconPin = function SvgIconPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_pin.e65b2e4a.svg";
export { ForwardRef as ReactComponent };